import { getPartnerDetails } from '../utils/helper'

// const user = window.location.toString().split('/')[3]
export const getConfigDetails = () => {
  const env = process.env
  return {
    // REQUIRED URLs -- always use env vars
    baseURL: env.REACT_APP_BASE_URL,
    partnerUrl: env.REACT_APP_PARTNER_PORTAL_URL,
    adminUrl: env.REACT_APP_ADMIN_PORTAL_URL,
    checkInUrl: env.REACT_APP_CHECKIN_PORTAL_URL,
    transientURL: env.REACT_APP_TRANSIENT_PORTAL_URL,
    ticketURL: env.REACT_APP_TICKET_PORTAL_URL,
    portalURL: env.REACT_APP_CUSTOMER_PORTAL_NAV_URL,
    portalBASEURL: env.REACT_APP_CUSTOMER_PORTAL_URL,

    // Optionals for supporting additional portals (if needed)
    revadminUrl: env.REACT_APP_REV_ADMIN_PORTAL_URL || '',
    revpartnerUrl: env.REACT_APP_REV_PARTNER_PORTAL_URL || '',
    revcheckInUrl: env.REACT_APP_REV_CHECKIN_PORTAL_URL || '',
    revtransientURL: env.REACT_APP_REV_TRANSIENT_PORTAL_URL || '',
    revticketURL: env.REACT_APP_REV_TICKET_PORTAL_URL || '',
    revportalURL: env.REACT_APP_REV_CUSTOMER_PORTAL_NAV_URL || '',
    revportalBASEURL: env.REACT_APP_REV_CUSTOMER_PORTAL_URL || '',

    // Permit and facility settings
    FACILITY_ID: env.REACT_APP_FACILITY_ID,
    FULL_SEASON: env.REACT_APP_PERMIT_FULL_SEASON_ID,
    HALF_SEASON: env.REACT_APP_PERMIT_HALF_SEASON_ID,
    SIX_PACK: env.REACT_APP_PERMIT_SIX_PACK_ID,

    // Secrets with possible override from partner details
    PARTNER_ID: getPartnerDetails()?.clients?.partner_id || env.REACT_APP_PARTNER_ID,
    CLIENT_ID: getPartnerDetails()?.clients?.id || env.REACT_APP_CLIENT_ID,
    CLIENT_SECRET: getPartnerDetails()?.clients?.secret || env.REACT_APP_CLIENT_SECRET || '',

    // Payment Scripts
    googlePayScript: env.REACT_APP_GOOGLE_PAY_SCRIPT_URL || null,
    googlePayDTScript: env.REACT_APP_GOOGLE_PAY_DT_SCRIPT_URL || null,
    googlePayHLScript: env.REACT_APP_GOOGLE_PAY_HL_SCRIPT_URL || null,

    applePayScript: env.REACT_APP_APPLE_PAY_SCRIPT_URL || null,
    applePayDTScript: env.REACT_APP_APPLE_PAY_DT_SCRIPT_URL || null,
    applePayHLScript: env.REACT_APP_APPLE_PAY_HL_SCRIPT_URL || null,

    payButtonScript: env.REACT_APP_PAY_BUTTON_SCRIPT_URL || null,
    payButtonDTScript: env.REACT_APP_PAY_BUTTON_DT_SCRIPT_URL || null,
    payButtonHLScript: env.REACT_APP_PAY_BUTTON_HL_SCRIPT_URL || null,

    encryptPublicKey: env.REACT_APP_PUBLIC_KEY || null,

    // Optional local/dev override URLs (if used in some deployments);
    eventLocalUrl: env.REACT_APP_EVENT_LOCAL_URL,
    adminLocalUrl: env.REACT_APP_ADMIN_LOCAL_URL,
    chiperKey: env.REACT_APP_CHIPER_KEY
  }
}
